<template>
  <div class="login" @keypress.enter="login">
    <i>The meta programmable note app</i>
    <div class="wrapper" ref="loginWrapper">
      <input type="text" placeholder="username" v-model="username">
      <input type="password" placeholder="password" v-model="password">
      <button class="button" @click="login">LOGIN</button>
    </div>
    <a href="#" class="demo-text" @click="$router.push({ path: '/demo' })">Request your demo</a>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      if (!this.username || !this.password) {
        this.shakeElement(this.$refs.loginWrapper)
        return
      }
      let url = this.$store.state.remoteUrl + '/_session'
      const requestBody = {
        name: this.username,
        password: this.password
      }
      const config = {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      }
      this.$store.commit('startLoading')
      axios.post(url, requestBody, config)
        .then((result) => {
          localStorage.setItem('username', result.data.name)
          this.$store.commit('setIsDebugBarVisible', result.data.name === 'dev')
          this.$router.push({ path: '/' })
        })
        .catch((err) => {
          console.log(err)
          this.shakeElement(this.$refs.loginWrapper)
        })
        .finally(() => {
          this.$store.commit('endLoading')
        })
    }
  }
}
</script>

<style lang="scss">
.login {
  display: grid;
  justify-items: center;

  .wrapper {
    display: grid;
    margin-top: 10px;
    padding: 20px;
    justify-self: center;
    width: 300px;

    input {
      padding: 0;
      background-color: transparent;
      border: none;
      border-bottom: solid 1px #f8fff7;
      color: white;
      height: 30px;
      text-align: center;
      margin-bottom: 10px;

      &::placeholder {
        color: #d4d4d4;
      }
    }
    button {
      justify-self: center;
    }
  }
}
.demo-text {
  justify-self: center;
  color: white;
}
</style>
